import { faChartSimple, faHouse, faTrophy, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';

const handleScrollClick = (slide) => {

    let element = document.getElementById(slide)
    element.scrollIntoView({ behavior: 'smooth' })
    
}

const menuItems = [
    /*{ 
        title: 'Home', 
        route: '/home', 
        icon: faHouse 
    },
    { 
        title: 'Leagues', 
        route: '/leagues', 
        icon: faTrophy
    },*/
    {
        title: "Dashboard",
        route: '/dashboard',
        icon: faHouse,
        isCore: true,
    },
    { 
        title: 'Predict', 
        route: '/predict/groups',
        icon: faWandMagicSparkles,
        isCore: true,
    },
    { 
        title: 'Ranking', 
        route: '/ranking', 
        icon: faChartSimple,
        isCore: true, 
    },

    /*
    {
        title: "Home",
        //route: '/home#home',
        click: e => handleScrollClick('home'),
        icon: null,
        isCore: false,
    },
    {
        title: "How it works",
        //route: '/home#howitworks',
        click: e => handleScrollClick('howitworks'),
        icon: null,
        isCore: false,
    },
    {
        title: "Pricing",
        //route: '/home#pricing',
        click: e => handleScrollClick('pricing'),
        icon: null,
        isCore: false,
    }*/
]

export default menuItems